const SW_RELOAD_GUARD_KEY = 'av-sw-reload-at';
const SW_RELOAD_COOLDOWN_MS = 15_000;

let reloadScheduled = false;

function reloadForServiceWorkerUpdate() {
  if (reloadScheduled || typeof window === 'undefined') {
    return false;
  }

  const lastReloadAt = Number(window.sessionStorage.getItem(SW_RELOAD_GUARD_KEY) || 0);
  if (lastReloadAt && Date.now() - lastReloadAt < SW_RELOAD_COOLDOWN_MS) {
    return false;
  }

  reloadScheduled = true;
  window.sessionStorage.setItem(SW_RELOAD_GUARD_KEY, String(Date.now()));
  window.location.reload();
  return true;
}

/**
 * Registers the production service worker.
 * Skipped under Puppeteer (prerender), localhost, and non-production builds.
 */
export function registerServiceWorker() {
  if (typeof window === 'undefined') {
    return;
  }

  if (process.env.NODE_ENV !== 'production') {
    return;
  }

  if (!('serviceWorker' in navigator)) {
    return;
  }

  if (navigator.webdriver) {
    return;
  }

  if (/^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)) {
    return;
  }

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .register('/sw.js')
      .then((registration) => {
        registration.addEventListener('updatefound', () => {
          const installing = registration.installing;
          if (!installing) {
            return;
          }

          installing.addEventListener('statechange', () => {
            if (
              installing.state === 'installed' &&
              navigator.serviceWorker.controller
            ) {
              reloadForServiceWorkerUpdate();
            }
          });
        });
      })
      .catch((error) => {
        console.warn('[PWA] Service worker registration failed:', error);
      });
  });
}
